import ApiClient from './api-client'
export default class geoDbServiceClient {
  constructor (token, dataset) {
    this.client = new ApiClient(token, process.env.VUE_APP_GEOSERVICE_URL)
    this.dataset = dataset
  }

  getGeoJSON () {
    return this.client.get('geojson', { dataset: this.dataset })
  }

  async getBounds (params = {}) {
    const datasetInfos = await this.client.get(`tiles/${this.dataset}.json`, params)
    return datasetInfos.bounds
  }
}
